module.exports = __webpack_public_path__ + "static/img/content_left_bottom_qrcode.1ed4af0.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/content_left_bottom_qrcode.png
// module id = OBLU
// module chunks = 0